import styled from 'styled-components';
import { mainColour } from '../../variables';

const Link = styled.a`
  color: ${mainColour};
  display: block;
  font-weight: 700;
  text-decoration: none;
`;

export default Link;


// WEBPACK FOOTER //
// ./src/components/Footer/Link.js